<template>
  <div>
    <el-form>
      <el-row>
        <el-col :span="6">
          <el-form-item label="达人名称" label-width="80px">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="达人名称"
              @keyup.enter.native="getList()"
            >
            </el-input> </el-form-item
        ></el-col>
        <el-col :span="6">
          <el-form-item label="联系电话" label-width="80px">
            <el-select
              v-model="searchForm.phone"
              class="cus_width"
              clearable
              filterable
              :filter-method="handleFilter"
              placeholder="选择联系电话"
              @change="getList"
            >
              <el-option
                v-for="(item, index) in storeList"
                :key="index"
                :label="item.name + '(' + item.phone + ')'"
                :value="item.phone"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否计算推广量" label-width="120px">
            <el-select
              v-model="searchForm.isPromotion"
              placeholder="请选择"
              clearable
              style="width: 100%"
              @change="getList()"
            >
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="达人码是否生效" label-width="120px">
            <el-select
              v-model="searchForm.isTakeEffect"
              placeholder="请选择"
              clearable
              style="width: 100%"
              @change="getList()"
            >
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-button type="success" @click="getList()">搜索</el-button>
          <el-button
            v-if="hasAuth('sys:store:add')"
            style="margin-bottom: 20px"
            type="primary"
            @click="handleSet('null')"
            >添加
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:promotion')"
            style="margin-bottom: 20px"
            type="primary"
            :disabled="multipleSelection.length === 0"
            @click="handlePromotion('null', 0, 1)"
            >批量开启推广量计算
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:promotion')"
            style="margin-bottom: 20px"
            type="danger"
            :disabled="multipleSelection.length === 0"
            @click="handlePromotion('null', 1, 1)"
            >批量关闭推广量计算
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:takeEffect')"
            style="margin-bottom: 20px"
            type="primary"
            :disabled="multipleSelection.length === 0"
            @click="handleTakeEffect('null', 0, 0)"
            >批量开启达人码生效
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:takeEffect')"
            style="margin-bottom: 20px"
            type="danger"
            :disabled="multipleSelection.length === 0"
            @click="handleTakeEffect('null', 1, 0)"
            >批量关闭达人码生效
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      :height="calcHeight"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        label="达人名称"
        prop="name"
        width="200"
      />
      <el-table-column
        align="center"
        label="达人二维码"
        min-width="200"
        prop="address"
      >
        <template slot-scope="{ row }">
          <el-image
            :preview-src-list="[row.codeImg]"
            :src="row.codeImg"
            style="width: 100px; height: 60px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="是否计算推广量"
        prop="userName"
        width="130"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.isPromotion === 0" type="success">是 </el-tag>
          <el-tag v-else type="danger">否 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="达人码是否生效"
        prop="userName"
        width="130"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.isTakeEffect === 0" type="success">是 </el-tag>
          <el-tag v-else type="danger">否 </el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="效期" prop="userName" width="330">
        <template slot-scope="{ row }">
          {{ row.takeEffectStartTime || "" }} 至
          {{ row.takeEffectEndTime || "" }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="扫码下单人数"
        prop="num"
        width="120"
      >
        <template slot-scope="{ row }">
          <span style="color: red; cursor: pointer" @click="scan(row)">
            {{ row.num || "" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="达人位置"
        min-width="240"
        prop="address"
      >
        <template slot-scope="{ row }">
          {{ row.province || "" }}-{{ row.city || "" }}-{{ row.county || ""
          }}<br />
          {{ row.address || "" }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="达人管理员"
        prop="userName"
        width="160"
      >
        <template slot-scope="{ row }">
          {{ row.userName || "" }} <br />
          {{ row.userPhone || "" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="达人联系方式"
        prop="phone"
        width="160"
      />
      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
        width="160"
      />

      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="320"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:store:edit')"
            plain
            style="margin-bottom: 6px"
            type="primary"
            @click="UpdateButton(scope.row)"
            >编辑
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:gengai')"
            plain
            style="margin-bottom: 6px"
            type="primary"
            @click="xggly(scope.row)"
            >更改管理员
          </el-button>
          <el-button
            slot="reference"
            plain
            style="margin-bottom: 6px"
            type="danger"
            v-if="hasAuth('sys:store:del')"
            @click="delHandle(scope.row.id)"
            >删除</el-button
          >

          <el-button
            v-if="hasAuth('sys:store:promotion')"
            plain
            style="margin-bottom: 6px"
            :type="scope.row.isPromotion == 0 ? 'danger' : 'primary'"
            @click="
              handlePromotion(scope.row, scope.row.isPromotion == 0 ? 1 : 0, 1)
            "
            >{{
              scope.row.isPromotion === 0 ? "关闭推广量计算" : "开启推广量计算"
            }}
          </el-button>
          <el-button
            v-if="
              hasAuth(
                'sys:store:takeEffect',
                scope.row.isTakeEffect == 0 ? 1 : 0,
                0,
              )
            "
            plain
            style="margin-bottom: 6px"
            :type="scope.row.isTakeEffect == 0 ? 'danger' : 'primary'"
            @click="
              handleTakeEffect(
                scope.row,
                scope.row.isTakeEffect == 0 ? 1 : 0,
                0,
              )
            "
            >{{
              scope.row.isTakeEffect === 0 ? "关闭达人码生效" : "开启达人码生效"
            }}
          </el-button>
          <el-button
            v-if="hasAuth('sys:store:download')"
            plain
            style="margin-bottom: 6px"
            type="info"
            @click="downloadByBlob(scope.row)"
            >二维码下载
          </el-button>

          <el-button
            v-if="hasAuth('sys:store:download')"
            plain
            style="margin-bottom: 6px"
            type="success"
            @click="handleShopSetting(scope.row)"
            >达人产品配置
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="160px"
      >
        <el-form-item label="达人名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>

        <el-form-item label="管理员" prop="userId">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.nickName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                style="height: 40px; width: 100%"
                type="primary"
                @click="selectUser"
                >选择
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="达人位置" prop="prov">
          <el-cascader
            v-model="editForm.prov"
            :options="area"
            :props="{ value: 'name', label: 'name', children: 'area' }"
            clearable
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="达人详细地址" prop="address">
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
        <el-form-item label="达人介绍" prop="introduction">
          <el-input
            v-model="editForm.introduction"
            :rows="2"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否计算推广量" prop="isPromotion">
          <el-radio-group v-model="editForm.isPromotion">
            <el-radio :label="0">计算</el-radio>
            <el-radio :label="1">不计算</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否生效" prop="isTakeEffect">
          <el-radio-group v-model="editForm.isTakeEffect">
            <el-radio :label="0">生效</el-radio>
            <el-radio :label="1">不生效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="效期"
          prop="range"
          v-if="editForm.isTakeEffect == 0"
        >
          <el-date-picker
            v-model="editForm.range"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效提示语" prop="prompt">
          <el-input v-model="editForm.prompt" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="达人封面" prop="cover">
          <VploadImgs
            v-if="dialogVisible"
            :limit="1"
            :multble="false"
            :type="1"
            v-bind:file-list="filelist"
            @submitImg="getImg"
          >
          </VploadImgs>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >提交
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :before-close="handlClose"
      :visible.sync="visible"
      append-to-body
      title="选择人员"
      width="80%"
    >
      <div style="padding-bottom: 40px">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
              v-model="usersearchForm.name"
              clearable
              placeholder="用户昵称"
              @keyup.enter.native="getStoreGoods()"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" label-width="80px">
            <el-select
              v-model="usersearchForm.phone"
              class="cus_width"
              clearable
              filterable
              :filter-method="handleUserFilter"
              placeholder="选择联系电话"
              @change="getStoreGoods"
            >
              <el-option
                v-for="(item, index) in storeuserList"
                :key="index"
                :label="item.nickName + '(' + item.phone + ')'"
                :value="item.phone"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="success" @click="getStoreGoods()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="userList" border stripe style="width: 100%">
          <el-table-column align="center" label="用户头像" min-width="120">
            <template slot-scope="scope"
              ><img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用户昵称"
            min-width="120"
            prop="nickName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="用户手机号"
            min-width="120"
            prop="phone"
          ></el-table-column>
          <el-table-column
            align="center"
            label="性别"
            min-width="100"
            prop="phone"
          >
            <template slot-scope="{ row }">
              <span v-if="row.gender == 1"> 男 </span>
              <span v-if="row.gender == 2"> 女 </span>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="位置"
            min-width="200"
            prop="address"
          ></el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            prop="icon"
            width="200"
          >
            <template slot-scope="scope">
              <el-button plain type="success" @click="usersumbit(scope.row)"
                >选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="usersearchForm.pageNo"
          :page-size="usersearchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="usr_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleUserSizeChange"
          @current-change="handleUserCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      :before-close="handlClose"
      :visible.sync="scanvisible"
      append-to-body
      title="下单人员"
      width="80%"
    >
      <div style="padding-bottom: 40px">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
              v-model="scansearchForm.name"
              clearable
              placeholder="用户昵称"
              @keyup.enter.native="getscanGoods()"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" label-width="80px">
            <el-select
              v-model="scansearchForm.phone"
              class="cus_width"
              clearable
              filterable
              :filter-method="handleUserFilter"
              placeholder="选择联系电话"
              @change="getscanGoods"
            >
              <el-option
                v-for="item in storeuserList"
                :key="item.phone"
                :label="item.nickName + '(' + item.phone + ')'"
                :value="item.phone"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getscanGoods()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="scanList" border stripe style="width: 100%">
          <el-table-column align="center" label="用户头像" min-width="120">
            <template slot-scope="scope"
              ><img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用户昵称"
            min-width="120"
            prop="nickName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="用户手机号"
            min-width="120"
            prop="phone"
          ></el-table-column>
          <el-table-column
            align="center"
            label="位置"
            min-width="200"
            prop="address"
          ></el-table-column>
        </el-table>
        <el-pagination
          :current-page="scansearchForm.pageNo"
          :page-size="scansearchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="scan_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleScanSizeChange"
          @current-change="handleScanCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VploadImgs from "../inc/VploadImgThree";
import area from "../stash/area.json";

export default {
  name: "ConfigType",
  components: {
    VploadImgs,
  },
  data() {
    return {
      scanvisible: false,
      type: 1,
      id: null,
      userList: [],
      area,
      props: { multiple: true, value: "name", label: "name", children: "area" },
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      filelist: [],
      editForm: {
        prov: [],
        address: "",
        name: "",
        phone: "",
        nickName: null,
        userId: null,
        introduction: null,
        isPromotion: null,
        isTakeEffect: null,
        prompt: null,
        range: [],
      },
      total: 0,
      storeList: [],
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        phone: "",
        isPromotion: "",
        isTakeEffect: "",
      },
      usr_total: 0,
      storeuserList: [],
      usersearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      calcHeight: 0,
      scansearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      topScrollWidth: 0,
      psarea: [],
      scanList: [],
      scan_total: 0,
      visible: false,

      rules: {
        address: [{ required: true, message: "请输入", trigger: "change" }],
        phone: [{ required: true, message: "请输入", trigger: "change" }],
        name: [{ required: true, message: "请输入", trigger: "change" }],
        prov: [{ required: true, message: "请选择", trigger: "change" }],
        isPromotion: [{ required: true, message: "请选择", trigger: "change" }],
        isTakeEffect: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        prompt: [{ required: true, message: "请输入", trigger: "blur" }],
        range: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  created() {
    this.calcHeight = window.innerHeight - 300;
    this.getList();
    this.getSearchList("");
  },
  methods: {
    setScrollWidth() {
      this.$nextTick(() => {
        this.topScrollWidth =
          this.$refs.multipleTable.bodyWrapper.scrollWidth + "px";
      });
    },
    handleUserFilter(val) {
      if (this.scanvisible) {
        this.scansearchForm.phone = val;
      } else {
        this.usersearchForm.phone = val;
      }

      this.$axios
        .post("/admin/userBase/getUserList", {
          pageNo: 1,
          pageSize: 10,
          phone: val,
          name: "",
        })
        .then((res) => {
          this.storeuserList = res.data.records;
        });
    },
    getSearchList(val) {
      this.storeList = [];
      this.$axios
        .post("/admin/store/getStoreList", {
          pageNo: 1,
          pageSize: 10,
          phone: val,
        })
        .then((res) => {
          this.storeList = res.data.records;
        });
    },

    handleFilter(val) {
      this.searchForm.phone = val;
      this.getSearchList(val);
    },
    handleShopSetting(row) {
      this.$router.push({
        path: "/sys/shopsetting",
        query: {
          storePhone: row.phone,
          storeName: row.name,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    xggly(i) {
      this.id = i.id;

      this.selectUser();
      this.type = 2;
    },
    usersumbit(i) {
      console.log(this.type);
      if (this.type == 2) {
        this.$axios
          .post("/admin/store/addStoreUser", { id: this.id, userId: i.userId })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.visible = false;
            this.searchForm.pageNo = 1;
            this.getList();
          });
      }

      if (this.type == 1) {
        this.editForm.userId = i.userId;
        this.editForm.nickName = i.nickName;
        this.visible = false;
      }
    },

    handlePromotion(row, num, type) {
      var idList = [];
      if (row == "null") {
        idList = this.multipleSelection.map((item) => item.id);
      } else {
        idList = [row.id];
      }

      this.$confirm(
        `确定要${num == 0 ? "开启" : "关闭"}选中的数据的推广量计算吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        this.$axios
          .post("/admin/store/updateStatus", {
            idList: idList,
            isPromotion: num,
            type: type,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });

      console.log(idList);
    },
    handleTakeEffect(row, num, type) {
      var idList = [];
      if (row == "null") {
        idList = this.multipleSelection.map((item) => item.id);
      } else {
        idList = [row.id];
      }

      this.$confirm(
        `确定要${num == 0 ? "开启" : "关闭"}选中的数据的生效状态吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        this.$axios
          .post("/admin/store/updateStatus", {
            idList: idList,
            isTakeEffect: num,
            type: type,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });
    },

    downloadByBlob(row) {
      const that = this;
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.src = row.codeImg;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 1260;
        canvas.height = 900;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, 1260, 900);
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          that.download(url, row.name);
          // 用完释放URL对象
          URL.revokeObjectURL(url);
        });
      };
    },

    download(url, name) {
      const eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = url;
      eleLink.click();
      eleLink.remove();
    },
    scan(row) {
      if (row) {
        this.scansearchForm.id = row.id;
      }
      this.scanvisible = true;

      this.$axios
        .post("/admin/store/getStoreUserList", this.scansearchForm)
        .then((res) => {
          this.scanList = res.data.records;
          this.scan_total = res.data.total;
          this.handleUserFilter();
        });
    },
    getscanGoods() {
      this.scansearchForm.pageNo = 1;
      this.scan();
    },
    getuser() {
      this.$axios
        .post("/admin/userBase/getUserList", this.usersearchForm)
        .then((res) => {
          this.userList = res.data.records;
          this.usr_total = res.data.total;
        });
    },
    selectUser() {
      this.type = 1;
      this.usersearchForm = {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      };
      this.getuser();
      this.handleUserFilter();
      this.visible = true;
    },
    getStoreGoods() {
      this.usersearchForm.pageNo = 1;
      this.getuser();
    },
    handleScanSizeChange(val) {
      this.scansearchForm.pageSize = val;
      this.scan();
    },
    handleScanCurrentChange(val) {
      this.scansearchForm.pageNo = val;
      this.scan();
    },
    handleUserSizeChange(val) {
      this.usersearchForm.pageSize = val;
      this.getuser();
    },
    handleUserCurrentChange(val) {
      this.usersearchForm.pageNo = val;
      this.getuser();
    },
    getImg(i) {
      this.editForm.cover = i;
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.editForm));
          obj.province = obj.prov[0];
          obj.city = obj.prov[1];
          obj.county = obj.prov[2];
          var ruleForm = {
            address: obj.address,
            city: obj.city,
            county: obj.county,
            cover: obj.cover,
            introduction: obj.introduction,
            name: obj.name,
            phone: obj.phone,
            province: obj.province,
            userId: obj.userId,
            isPromotion: obj.isPromotion,
            isTakeEffect: obj.isTakeEffect,
            prompt: obj.prompt,
            takeEffectEndTime:
              obj.isTakeEffect == 0 && obj.range && obj.range.length > 0
                ? obj.range[1]
                : "",
            takeEffectStartTime:
              obj.isTakeEffect == 0 && obj.range && obj.range.length > 0
                ? obj.range[0]
                : "",
          };
          if (obj.id) {
            ruleForm.id = obj.id;
            this.$axios
              .post("/admin/store/updateStore", ruleForm)
              .then((res) => {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("editForm");
                this.searchForm.pageNo = 1;
                this.getList();
              });
          } else {
            this.$axios.post("/admin/store/addStore", ruleForm).then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {},
              });
              this.handleClose("editForm");
              this.searchForm.pageNo = 1;
              this.getList();
            });
          }
        }
      });
    },
    getList() {
      this.$axios
        .post("/admin/store/getStoreList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    handleSet() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.editForm = {
        name: null,
        phone: null,
        type: null,
        prov: [],
        address: null,
        entrepot: [],
      };
      this.fileList = [];
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    handlClose() {
      this.visible = false;
      this.scanvisible = false;
    },

    UpdateButton(row, type) {
      this.$axios
        .post("/admin/store/getStoreInfo", { id: row.id })
        .then((res) => {
          res.data.prov = [res.data.province, res.data.city, res.data.county];
          this.$nextTick(() => {
            this.editForm = {
              introduction: res.data.introduction,
              name: res.data.name,
              phone: res.data.phone,
              prov: res.data.prov,
              address: res.data.address,
              id: res.data.id,
              cover: res.data.cover,
              userId: res.data.userId,
              nickName: res.data.userName,
              isPromotion: res.data.isPromotion,
              isTakeEffect: res.data.isTakeEffect,
              prompt: res.data.prompt,
              range:
                res.data.takeEffectStartTime && res.data.takeEffectEndTime
                  ? [res.data.takeEffectStartTime, res.data.takeEffectEndTime]
                  : [],
            };
            this.filelist = [{ url: res.data.cover }];
            this.dialogVisible = true;
          });
        });
    },
    delHandle(id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/store/deleteStore", {
            id: id,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.cus_area {
  margin: 10px;
}
.fiex_t {
  width: calc(100% - 240px);
  height: 8px;
  position: fixed;
  bottom: 14px;
  z-index: 9999;
}

.top-scroll {
  width: 100%;
  overflow-x: auto;
}

.top-scroll-content {
  height: 6px;
}
</style>
